var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p_box" },
    _vm._l(_vm.commentList, function (item, index) {
      return _c("div", { key: index }, [
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticClass: "p_left" }, [
            _c("img", { attrs: { src: item.from_user.avatar, alt: "" } }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p_right" },
            [
              _c("div", { staticClass: "p_name" }, [
                _c("span", [_vm._v(_vm._s(item.from_user.name))]),
                _vm._v(" "),
                item.from_user.id == _vm.userId
                  ? _c("span", {
                      staticClass: "iconfont iconshanchu1",
                      on: {
                        click: function ($event) {
                          return _vm.commentDel(item)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "p_content" }, [
                _vm._v("\n          " + _vm._s(item.content) + "\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "p_time" }, [
                _vm._v(_vm._s(item.created_at) + " "),
                _c(
                  "span",
                  {
                    staticClass: "reply",
                    on: {
                      click: function ($event) {
                        return _vm.replyFn(item)
                      },
                    },
                  },
                  [_vm._v("回复")]
                ),
              ]),
              _vm._v(" "),
              item.children.length !== 0
                ? _vm._l(item.children, function (per, v) {
                    return _c("div", { key: v, staticClass: "flex mt14" }, [
                      _c("div", { staticClass: "p_left" }, [
                        _c("img", {
                          attrs: { src: per.from_user.avatar, alt: "" },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "p_right" }, [
                        _c("div", { staticClass: "p_name" }, [
                          _c("span", [_vm._v(_vm._s(per.from_user.name))]),
                          _vm._v(" "),
                          per.from_user.id == _vm.userId
                            ? _c("span", {
                                staticClass: "iconfont iconshanchu1",
                                on: {
                                  click: function ($event) {
                                    return _vm.commentDel(per)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p_content" }, [
                          _c("span", { staticClass: "p_time" }, [
                            _vm._v(" 回复" + _vm._s(per.to_user.name) + " : "),
                          ]),
                          _vm._v(
                            " " + _vm._s(per.content) + "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p_time" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(per.created_at) +
                              "\n                "
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "reply",
                              on: {
                                click: function ($event) {
                                  return _vm.replyFn(item, per)
                                },
                              },
                            },
                            [_vm._v("回复")]
                          ),
                        ]),
                      ]),
                    ])
                  })
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "splitLine" }),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }